import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Dialog, Link } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import {
  getActiveSessions,
  updateSession,
} from "../../services/securityService";
import { useTranslation } from "react-i18next";
import { dateParser } from "../../helper";
import "./Auth.scss";

const SessionsListView = (props: any) => {
  const { open, onClose, isDialog, username, temporaryToken } = props;
  const { t, i18n } = useTranslation();

  const [activeSessions, setActiveSessions] = useState([] as any[]);

  const fetchActiveSessions = () => {
    getActiveSessions(username, isDialog ? temporaryToken : null).then(
      (res: any) => {
        let sessionId: any;
        const token = localStorage.getItem("token") || "";
        if (!isDialog) {
          sessionId = JSON.parse(atob(token?.split(".")[1]))?.iss?.sessionId;
        }
        if (res?.data?.length) {
          if (isDialog && res.data.length < 2) {
            onClose();
          } else {
            const sessions: any[] = [];
            res.data.forEach((eachSession: any) => {
              sessions.push({
                ...eachSession,
                currentSession: eachSession.sessionIdentifier === sessionId,
              });
            });
            setActiveSessions(sessions);
          }
        } else {
          setActiveSessions([]);
        }
      }
    );
  };

  const handleSessionLogout = (sessionId: string) => {
    if (sessionId?.length) {
      updateSession(
        {
          sessionId,
        },
        isDialog ? temporaryToken : null
      ).then((res) => {
        fetchActiveSessions();
      });
    }
  };

  useEffect(() => {
    fetchActiveSessions();
  }, []);

  return (
    <Fragment>
      {isDialog ? (
        <div>
          <Dialog className="pw-confirmation-dialog" open={open}>
            <div className="w-full h-64">
              {activeSessions?.length ? (
                <div className="pw-addressbox w-full my-4">
                  <div className="font-bold text-md">
                    {t("Acitive sessions limit reached")}
                  </div>
                  <div className="pw-sessions-info my-2">
                    {t(
                      "Please log out from other devices to sign in from here"
                    )}
                  </div>

                  {activeSessions.map((eachSession: any, index) => (
                    <div
                      key={index}
                      className="flex flex-col w-full mt-4 pr-12 pl-4"
                    >
                      <div className="flex flex-row justify-between items-center w-2/3">
                        <div className="font-bold text-sm">
                          {dateParser(eachSession.loggedInAt)}
                        </div>
                        {eachSession.currentSession ? (
                          <div className="text-xs pw-primary-color">
                            current session
                          </div>
                        ) : (
                          <div
                            className="text-xs cursor-pointer pw-logout-color"
                            onClick={() => {
                              handleSessionLogout(
                                eachSession.sessionIdentifier
                              );
                            }}
                          >
                            logout
                          </div>
                        )}
                      </div>
                      <div className="text-xs flex flex-row w-full">
                        {eachSession.deviceType}
                        {eachSession.deviceType && eachSession.browserType
                          ? " - "
                          : ""}
                        {eachSession.browserType}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="flex flex-row justify-end pw-confirmation-dialog-footer !pr-4 w-full gap-6 py-3 mt-4">
              <div
                className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
                onClick={onClose}
              >
                Cancel
              </div>
            </div>
          </Dialog>
        </div>
      ) : (
        <div className="w-full">
          {activeSessions?.length ? (
            <div className="pw-addressbox w-full bg-white pb-4">
              <div className="pw-sessions-header">
                {t("Acitive Sessions")} ({activeSessions?.length})
              </div>

              {activeSessions.map((eachSession: any, index) => (
                <div key={index} className="flex flex-col w-full mt-4">
                  <div className="flex flex-row justify-between items-center w-full pr-6">
                    <div className="font-bold text-sm">
                      {dateParser(eachSession.loggedInAt)}
                    </div>
                    {eachSession.currentSession ? (
                      <div className="text-xs pw-primary-color">
                        current session
                      </div>
                    ) : (
                      <div
                        className="text-xs cursor-pointer pw-logout-color"
                        onClick={() => {
                          handleSessionLogout(eachSession.sessionIdentifier);
                        }}
                      >
                        logout
                      </div>
                    )}
                  </div>
                  <div className="text-xs flex flex-row w-full">
                    {eachSession.deviceType}
                    {eachSession.deviceType && eachSession.browserType
                      ? " - "
                      : ""}
                    {eachSession.browserType}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </Fragment>
  );
};

export default SessionsListView;
